import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { forgotPassword } from '../../services/userService';
import { Card, Button, Row, Col, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { byPrefixAndName } from '@awesome.me/kit-8685c875a9/icons';
import '../../scss/components/login.scss';

const ForgotPasswordForm = () => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        setLoading(true);

        try {
            await forgotPassword(email);
            setSuccess("If an account exists for this email address, we'll send you instructions to reset your password.");
        } catch (err) {
            console.error(err);
            setError('Failed to send reset email');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Row className="justify-content-center align-items-center vh-100 m-0">
            <Col xs={12} md={6} lg={5} xl={4}>
                <Row>
                    <Col>
                        <img
                            className="d-block mx-auto img-fluid mb-4"
                            width="75"
                            src="/bestU.png"
                            alt="Logo"
                        />
                    </Col>
                </Row>
                <Card className="p-4 shadow-lg border-0 rounded-4">
                    <Card.Body>
                        <div className="text-center mb-4">
                            <FontAwesomeIcon icon={byPrefixAndName.fas['key']} />
                            <h3 className="mt-2">Forgot Password</h3>
                        </div>

                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3">
                                <Form.Label>Email address</Form.Label>
                                <Form.Control
                                    type="email"
                                    placeholder="Enter email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    disabled={loading}
                                />
                            </Form.Group>

                            {error && <p className="text-danger text-center">{error}</p>}
                            {success && <p className="text-success text-center">{success}</p>}

                            <div className="text-center mb-3">
                                <Button type="submit" variant="primary" disabled={loading}>
                                    {loading ? 'Sending...' : 'Send Reset Email'}
                                </Button>
                            </div>

                            <div className="text-center">
                                <Link to="/" className="text-decoration-none">
                                    Back to Login
                                </Link>
                            </div>
                        </Form>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
};

export default ForgotPasswordForm;
